import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { firstValueFrom } from 'rxjs'

import { TargetApiRoutes } from '../enums/target-api-routes.enum'
import { Environment } from '../interfaces/environment.interface'
import { Country } from '../interfaces/resources/country.interface'
import { EnvironmentService } from './environment.service'

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  environment: Environment

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) {
    this.environmentService.loadEnvironment().subscribe((env) => {
      this.environment = env
    })
  }

  async list(): Promise<Country[]> {
    return firstValueFrom(
      this.http.get(
        `${this.environment.apiBaseUrl}${TargetApiRoutes.Countries}`
      )
    ).then((countriesRes: Object) => {
      return countriesRes as Country[]
    })
  }

  async show(id: string): Promise<Country> {
    return firstValueFrom(
      this.http.get(
        `${this.environment.apiBaseUrl}${TargetApiRoutes.Country}&id=${id}`
      )
    ).then((countryRes: Object) => {
      return countryRes as Country
    })
  }
}
